module.exports = __webpack_public_path__ + "media/video_login.6f4bc0c1.mp4";